import { Typography } from 'components/Typography';

type Props = {
    textId: string;
};

export const SnapshotTitle = ({ textId }: Props): JSX.Element => (
    <Typography bold allCapitalized variant="h5" textId={textId} />
);
